"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GBET = void 0;
// eslint-disable-next-line @typescript-eslint/no-namespace
var GBET;
(function (GBET) {
    let QuestionType;
    (function (QuestionType) {
        QuestionType[QuestionType["PlaceOfBirth"] = 1] = "PlaceOfBirth";
        QuestionType[QuestionType["MothersMaidenName"] = 2] = "MothersMaidenName";
        QuestionType[QuestionType["FirstSchool"] = 3] = "FirstSchool";
        QuestionType[QuestionType["FavouriteColour"] = 4] = "FavouriteColour";
        QuestionType[QuestionType["FavouriteHolidayDestination"] = 5] = "FavouriteHolidayDestination";
        QuestionType[QuestionType["AllTimeFavouriteJockey"] = 6] = "AllTimeFavouriteJockey";
        QuestionType[QuestionType["FavouriteAutomobile"] = 7] = "FavouriteAutomobile";
        QuestionType[QuestionType["FirstPetsName"] = 8] = "FirstPetsName";
        QuestionType[QuestionType["AllTimeFavouriteHorse"] = 9] = "AllTimeFavouriteHorse";
        QuestionType[QuestionType["CityOfBirth"] = 10] = "CityOfBirth";
        QuestionType[QuestionType["Unspecified"] = 11] = "Unspecified";
        QuestionType[QuestionType["PaternalGrandfatherFirstName"] = 12] = "PaternalGrandfatherFirstName";
        QuestionType[QuestionType["ChildhoodFriend"] = 13] = "ChildhoodFriend";
        QuestionType[QuestionType["HighschoolMascot"] = 14] = "HighschoolMascot";
        QuestionType[QuestionType["FirstCar"] = 15] = "FirstCar";
    })(QuestionType = GBET.QuestionType || (GBET.QuestionType = {}));
    let Sex;
    (function (Sex) {
        Sex[Sex["Male"] = 1] = "Male";
        Sex[Sex["Female"] = 2] = "Female";
    })(Sex = GBET.Sex || (GBET.Sex = {}));
    let Title;
    (function (Title) {
        Title[Title["Mr"] = 1] = "Mr";
        Title[Title["Mrs"] = 2] = "Mrs";
        Title[Title["Ms"] = 3] = "Ms";
        Title[Title["Dr"] = 4] = "Dr";
        Title[Title["Other"] = 5] = "Other";
    })(Title = GBET.Title || (GBET.Title = {}));
    let MarketType;
    (function (MarketType) {
        MarketType[MarketType["Win"] = 1] = "Win";
        MarketType[MarketType["Place"] = 2] = "Place";
        MarketType[MarketType["MatchOdds"] = 3] = "MatchOdds";
        MarketType[MarketType["OverUnder"] = 4] = "OverUnder";
        MarketType[MarketType["AsianHandicap"] = 10] = "AsianHandicap";
        MarketType[MarketType["TwoBall"] = 11] = "TwoBall";
        MarketType[MarketType["ThreeBall"] = 12] = "ThreeBall";
        MarketType[MarketType["Unspecified"] = 13] = "Unspecified";
        MarketType[MarketType["MatchMarket"] = 14] = "MatchMarket";
        MarketType[MarketType["SetMarket"] = 15] = "SetMarket";
        MarketType[MarketType["Moneyline"] = 16] = "Moneyline";
        MarketType[MarketType["Total"] = 17] = "Total";
        MarketType[MarketType["Handicap"] = 18] = "Handicap";
        MarketType[MarketType["EachWayNonHandicap"] = 19] = "EachWayNonHandicap";
        MarketType[MarketType["EachWayHandicap"] = 20] = "EachWayHandicap";
        MarketType[MarketType["EachWayTournament"] = 21] = "EachWayTournament";
        MarketType[MarketType["RunningBall"] = 22] = "RunningBall";
        MarketType[MarketType["MatchBetting"] = 23] = "MatchBetting";
        MarketType[MarketType["MatchBettingInclDraw"] = 24] = "MatchBettingInclDraw";
        MarketType[MarketType["CorrectScore"] = 25] = "CorrectScore";
        MarketType[MarketType["HalfTimeFullTime"] = 26] = "HalfTimeFullTime";
        MarketType[MarketType["TotalGoals"] = 27] = "TotalGoals";
        MarketType[MarketType["GoalsScored"] = 28] = "GoalsScored";
        MarketType[MarketType["Corners"] = 29] = "Corners";
        MarketType[MarketType["OddsOrEvens"] = 30] = "OddsOrEvens";
        MarketType[MarketType["HalfTimeResult"] = 31] = "HalfTimeResult";
        MarketType[MarketType["HalfTimeScore"] = 32] = "HalfTimeScore";
        MarketType[MarketType["MatchOddsExtraTime"] = 33] = "MatchOddsExtraTime";
        MarketType[MarketType["CorrectScoreExtraTime"] = 34] = "CorrectScoreExtraTime";
        MarketType[MarketType["OverUnderExtraTime"] = 35] = "OverUnderExtraTime";
        MarketType[MarketType["ToQualify"] = 36] = "ToQualify";
        MarketType[MarketType["DrawNoBet"] = 37] = "DrawNoBet";
        MarketType[MarketType["HalftimeAsianHcp"] = 39] = "HalftimeAsianHcp";
        MarketType[MarketType["HalftimeOverUnder"] = 40] = "HalftimeOverUnder";
        MarketType[MarketType["NextGoal"] = 41] = "NextGoal";
        MarketType[MarketType["FirstGoalscorer"] = 42] = "FirstGoalscorer";
        MarketType[MarketType["LastGoalscorer"] = 43] = "LastGoalscorer";
        MarketType[MarketType["PlayerToScore"] = 44] = "PlayerToScore";
        MarketType[MarketType["FirstHalfHandicap"] = 45] = "FirstHalfHandicap";
        MarketType[MarketType["FirstHalfTotal"] = 46] = "FirstHalfTotal";
        MarketType[MarketType["SetBetting"] = 47] = "SetBetting";
        MarketType[MarketType["GroupBetting"] = 48] = "GroupBetting";
        MarketType[MarketType["MatchplaySingle"] = 49] = "MatchplaySingle";
        MarketType[MarketType["MatchplayFourball"] = 50] = "MatchplayFourball";
        MarketType[MarketType["MatchplayFoursome"] = 51] = "MatchplayFoursome";
        MarketType[MarketType["TiedMatch"] = 52] = "TiedMatch";
        MarketType[MarketType["TopBatsman"] = 53] = "TopBatsman";
        MarketType[MarketType["InningsRuns"] = 54] = "InningsRuns";
        MarketType[MarketType["TotalTries"] = 55] = "TotalTries";
        MarketType[MarketType["TotalPoints"] = 56] = "TotalPoints";
        MarketType[MarketType["FrameBetting"] = 57] = "FrameBetting";
        MarketType[MarketType["ToScoreFirst"] = 58] = "ToScoreFirst";
        MarketType[MarketType["ToScoreLast"] = 59] = "ToScoreLast";
        MarketType[MarketType["FirstScoringPlay"] = 60] = "FirstScoringPlay";
    })(MarketType = GBET.MarketType || (GBET.MarketType = {}));
    let OrderFillType;
    (function (OrderFillType) {
        OrderFillType[OrderFillType["Normal"] = 1] = "Normal";
        OrderFillType[OrderFillType["FillAndKill"] = 2] = "FillAndKill";
        OrderFillType[OrderFillType["FillOrKill"] = 3] = "FillOrKill";
        OrderFillType[OrderFillType["FillOrKillDontCancel"] = 4] = "FillOrKillDontCancel";
        OrderFillType[OrderFillType["SPIfUnmatched"] = 5] = "SPIfUnmatched";
    })(OrderFillType = GBET.OrderFillType || (GBET.OrderFillType = {}));
    let MultipleBetStatus;
    (function (MultipleBetStatus) {
        MultipleBetStatus[MultipleBetStatus["Active"] = 1] = "Active";
        MultipleBetStatus[MultipleBetStatus["Voided"] = 2] = "Voided";
        MultipleBetStatus[MultipleBetStatus["SettledFor"] = 3] = "SettledFor";
        MultipleBetStatus[MultipleBetStatus["SettledAgainst"] = 4] = "SettledAgainst";
        MultipleBetStatus[MultipleBetStatus["SettledUnclaimed"] = 5] = "SettledUnclaimed";
        MultipleBetStatus[MultipleBetStatus["CashedOut"] = 6] = "CashedOut";
    })(MultipleBetStatus = GBET.MultipleBetStatus || (GBET.MultipleBetStatus = {}));
    let MultipleLegStatus;
    (function (MultipleLegStatus) {
        MultipleLegStatus[MultipleLegStatus["Unknown"] = 1] = "Unknown";
        MultipleLegStatus[MultipleLegStatus["Won"] = 2] = "Won";
        MultipleLegStatus[MultipleLegStatus["Lost"] = 3] = "Lost";
        MultipleLegStatus[MultipleLegStatus["Voided"] = 4] = "Voided";
    })(MultipleLegStatus = GBET.MultipleLegStatus || (GBET.MultipleLegStatus = {}));
    let SelectionStatus;
    (function (SelectionStatus) {
        SelectionStatus[SelectionStatus["Inactive"] = 1] = "Inactive";
        SelectionStatus[SelectionStatus["Active"] = 2] = "Active";
        SelectionStatus[SelectionStatus["Suspended"] = 3] = "Suspended";
        SelectionStatus[SelectionStatus["Withdrawn"] = 4] = "Withdrawn";
        SelectionStatus[SelectionStatus["Voided"] = 5] = "Voided";
        SelectionStatus[SelectionStatus["Completed"] = 6] = "Completed";
        SelectionStatus[SelectionStatus["ResultsSet"] = 7] = "ResultsSet";
        SelectionStatus[SelectionStatus["Settled"] = 8] = "Settled";
        SelectionStatus[SelectionStatus["BallotedOut"] = 9] = "BallotedOut";
    })(SelectionStatus = GBET.SelectionStatus || (GBET.SelectionStatus = {}));
    let SportsBetPriceType;
    (function (SportsBetPriceType) {
        SportsBetPriceType[SportsBetPriceType["FixedPrice"] = 1] = "FixedPrice";
        SportsBetPriceType[SportsBetPriceType["StartingPrice"] = 2] = "StartingPrice";
        SportsBetPriceType[SportsBetPriceType["BestOddsGuaranteed"] = 3] = "BestOddsGuaranteed";
    })(SportsBetPriceType = GBET.SportsBetPriceType || (GBET.SportsBetPriceType = {}));
    let ChannelType;
    (function (ChannelType) {
        ChannelType[ChannelType["Internet"] = 1] = "Internet";
        ChannelType[ChannelType["Mobile"] = 2] = "Mobile";
        ChannelType[ChannelType["Telebetting"] = 3] = "Telebetting";
        ChannelType[ChannelType["API"] = 4] = "API";
        ChannelType[ChannelType["LightweightPrice"] = 5] = "LightweightPrice";
        ChannelType[ChannelType["Kiosk"] = 6] = "Kiosk";
        ChannelType[ChannelType["GBEIntegrationSolution"] = 7] = "GBEIntegrationSolution";
        ChannelType[ChannelType["GBEIntegrationSolutionTelebetting"] = 8] = "GBEIntegrationSolutionTelebetting";
    })(ChannelType = GBET.ChannelType || (GBET.ChannelType = {}));
    let GranularChannelType;
    (function (GranularChannelType) {
        GranularChannelType[GranularChannelType["MobileBrowser"] = 1] = "MobileBrowser";
        GranularChannelType[GranularChannelType["TabletBrowser"] = 2] = "TabletBrowser";
        GranularChannelType[GranularChannelType["MobileApplication"] = 3] = "MobileApplication";
        GranularChannelType[GranularChannelType["TabletApplication"] = 4] = "TabletApplication";
        GranularChannelType[GranularChannelType["InternetBrowser"] = 5] = "InternetBrowser";
        GranularChannelType[GranularChannelType["InternetApplication"] = 6] = "InternetApplication";
        GranularChannelType[GranularChannelType["LiveOperator"] = 7] = "LiveOperator";
        GranularChannelType[GranularChannelType["SelfService"] = 8] = "SelfService";
        GranularChannelType[GranularChannelType["API"] = 9] = "API";
    })(GranularChannelType = GBET.GranularChannelType || (GBET.GranularChannelType = {}));
    let WithdrawRepriceOption;
    (function (WithdrawRepriceOption) {
        WithdrawRepriceOption[WithdrawRepriceOption["Reprice"] = 1] = "Reprice";
        WithdrawRepriceOption[WithdrawRepriceOption["Cancel"] = 2] = "Cancel";
        WithdrawRepriceOption[WithdrawRepriceOption["DontReprice"] = 3] = "DontReprice";
    })(WithdrawRepriceOption = GBET.WithdrawRepriceOption || (GBET.WithdrawRepriceOption = {}));
    let FundsTransferTransactionType;
    (function (FundsTransferTransactionType) {
        FundsTransferTransactionType[FundsTransferTransactionType["WithdrawFunds"] = 1] = "WithdrawFunds";
        FundsTransferTransactionType[FundsTransferTransactionType["LodgeFunds"] = 2] = "LodgeFunds";
    })(FundsTransferTransactionType = GBET.FundsTransferTransactionType || (GBET.FundsTransferTransactionType = {}));
    let FundsTransferMethodType;
    (function (FundsTransferMethodType) {
        FundsTransferMethodType[FundsTransferMethodType["DebitCard"] = 1] = "DebitCard";
        FundsTransferMethodType[FundsTransferMethodType["CreditCard"] = 2] = "CreditCard";
        FundsTransferMethodType[FundsTransferMethodType["ChequeIn"] = 3] = "ChequeIn";
        FundsTransferMethodType[FundsTransferMethodType["ChequeOut"] = 4] = "ChequeOut";
        FundsTransferMethodType[FundsTransferMethodType["ElectronicFundsTransferIn"] = 5] = "ElectronicFundsTransferIn";
        FundsTransferMethodType[FundsTransferMethodType["ElectronicFundsTransferOut"] = 6] = "ElectronicFundsTransferOut";
        FundsTransferMethodType[FundsTransferMethodType["InternetPaymentProvider"] = 7] = "InternetPaymentProvider";
        FundsTransferMethodType[FundsTransferMethodType["BankTransfer"] = 8] = "BankTransfer";
        FundsTransferMethodType[FundsTransferMethodType["MCard"] = 9] = "MCard";
        FundsTransferMethodType[FundsTransferMethodType["OTC"] = 10] = "OTC";
        FundsTransferMethodType[FundsTransferMethodType["Agent"] = 11] = "Agent";
        FundsTransferMethodType[FundsTransferMethodType["WesternUnion"] = 12] = "WesternUnion";
        FundsTransferMethodType[FundsTransferMethodType["Paysafe"] = 13] = "Paysafe";
        FundsTransferMethodType[FundsTransferMethodType["MoneyBookers"] = 14] = "MoneyBookers";
        FundsTransferMethodType[FundsTransferMethodType["Neteller"] = 15] = "Neteller";
        FundsTransferMethodType[FundsTransferMethodType["ExternalSystem2"] = 16] = "ExternalSystem2";
        FundsTransferMethodType[FundsTransferMethodType["ExternalSystem1"] = 17] = "ExternalSystem1";
        FundsTransferMethodType[FundsTransferMethodType["OnCourseCash"] = 18] = "OnCourseCash";
        FundsTransferMethodType[FundsTransferMethodType["WebMoney"] = 19] = "WebMoney";
        FundsTransferMethodType[FundsTransferMethodType["ACH"] = 20] = "ACH";
    })(FundsTransferMethodType = GBET.FundsTransferMethodType || (GBET.FundsTransferMethodType = {}));
    let PostingType;
    (function (PostingType) {
        PostingType[PostingType["Settlement"] = 1] = "Settlement";
        PostingType[PostingType["Commission"] = 2] = "Commission";
        PostingType[PostingType["Transfer"] = 3] = "Transfer";
        PostingType[PostingType["Lodgement"] = 4] = "Lodgement";
        PostingType[PostingType["Withdrawal"] = 5] = "Withdrawal";
        PostingType[PostingType["TransferToSportsbook"] = 6] = "TransferToSportsbook";
        PostingType[PostingType["TransferFromSportsbook"] = 7] = "TransferFromSportsbook";
        PostingType[PostingType["SinglePurseStakeTransfer"] = 8] = "SinglePurseStakeTransfer";
        PostingType[PostingType["SinglePursePosting"] = 9] = "SinglePursePosting";
        PostingType[PostingType["DeviceStakeTransfer"] = 10] = "DeviceStakeTransfer";
        PostingType[PostingType["DevicePayoutPayment"] = 11] = "DevicePayoutPayment";
        PostingType[PostingType["Tax"] = 12] = "Tax";
        PostingType[PostingType["GamePlay"] = 13] = "GamePlay";
        PostingType[PostingType["AdvancePayment"] = 14] = "AdvancePayment";
        PostingType[PostingType["Bonus"] = 15] = "Bonus";
        PostingType[PostingType["Reward"] = 16] = "Reward";
        PostingType[PostingType["Stake"] = 17] = "Stake";
        PostingType[PostingType["Refund"] = 18] = "Refund";
        PostingType[PostingType["Adjustment"] = 19] = "Adjustment";
        PostingType[PostingType["ProductPurchase"] = 20] = "ProductPurchase";
        PostingType[PostingType["ProductRefund"] = 21] = "ProductRefund";
    })(PostingType = GBET.PostingType || (GBET.PostingType = {}));
    let FTMRStatus;
    (function (FTMRStatus) {
        FTMRStatus[FTMRStatus["Enabled"] = 1] = "Enabled";
        FTMRStatus[FTMRStatus["Blocked"] = 2] = "Blocked";
        FTMRStatus[FTMRStatus["Removed"] = 3] = "Removed";
    })(FTMRStatus = GBET.FTMRStatus || (GBET.FTMRStatus = {}));
    let PurseIntegrationMode;
    (function (PurseIntegrationMode) {
        PurseIntegrationMode[PurseIntegrationMode["SinglePurse"] = 1] = "SinglePurse";
        PurseIntegrationMode[PurseIntegrationMode["FundsTransfer"] = 2] = "FundsTransfer";
    })(PurseIntegrationMode = GBET.PurseIntegrationMode || (GBET.PurseIntegrationMode = {}));
    let ContactType;
    (function (ContactType) {
        ContactType[ContactType["Unknown"] = 1] = "Unknown";
        ContactType[ContactType["PressAdvertisment"] = 2] = "PressAdvertisment";
        ContactType[ContactType["PressArticle"] = 3] = "PressArticle";
        ContactType[ContactType["SearchEngine"] = 4] = "SearchEngine";
        ContactType[ContactType["OtherService"] = 5] = "OtherService";
        ContactType[ContactType["ReferAFriendProgram"] = 6] = "ReferAFriendProgram";
        ContactType[ContactType["TVOrRadio"] = 7] = "TVOrRadio";
        ContactType[ContactType["Promotion"] = 8] = "Promotion";
    })(ContactType = GBET.ContactType || (GBET.ContactType = {}));
    let BettingTypeId;
    (function (BettingTypeId) {
        BettingTypeId[BettingTypeId["Undefined"] = 0] = "Undefined";
        BettingTypeId[BettingTypeId["Both"] = 1] = "Both";
        BettingTypeId[BettingTypeId["ExchangeOnly"] = 2] = "ExchangeOnly";
        BettingTypeId[BettingTypeId["SportsbookOnly"] = 3] = "SportsbookOnly";
    })(BettingTypeId = GBET.BettingTypeId || (GBET.BettingTypeId = {}));
    let Polarity;
    (function (Polarity) {
        Polarity[Polarity["For"] = 1] = "For";
        Polarity[Polarity["Against"] = 2] = "Against";
    })(Polarity = GBET.Polarity || (GBET.Polarity = {}));
    let PriceFormat;
    (function (PriceFormat) {
        PriceFormat[PriceFormat["Decimal"] = 1] = "Decimal";
        PriceFormat[PriceFormat["Fractional"] = 2] = "Fractional";
        PriceFormat[PriceFormat["American"] = 3] = "American";
    })(PriceFormat = GBET.PriceFormat || (GBET.PriceFormat = {}));
    let PromotionType;
    (function (PromotionType) {
        PromotionType[PromotionType["Normal"] = 1] = "Normal";
        PromotionType[PromotionType["RetentionPromotion"] = 2] = "RetentionPromotion";
        PromotionType[PromotionType["SignOnPromotion"] = 3] = "SignOnPromotion";
        PromotionType[PromotionType["ReferAFriend"] = 4] = "ReferAFriend";
        PromotionType[PromotionType["DepositBoost"] = 5] = "DepositBoost";
    })(PromotionType = GBET.PromotionType || (GBET.PromotionType = {}));
    let MarketStatus;
    (function (MarketStatus) {
        MarketStatus[MarketStatus["Inactive"] = 1] = "Inactive";
        MarketStatus[MarketStatus["Active"] = 2] = "Active";
        MarketStatus[MarketStatus["Suspended"] = 3] = "Suspended";
        MarketStatus[MarketStatus["Completed"] = 4] = "Completed";
        MarketStatus[MarketStatus["ResultsSet"] = 5] = "ResultsSet";
        MarketStatus[MarketStatus["Settled"] = 6] = "Settled";
        MarketStatus[MarketStatus["Voided"] = 7] = "Voided";
    })(MarketStatus = GBET.MarketStatus || (GBET.MarketStatus = {}));
    let OrderStatus;
    (function (OrderStatus) {
        OrderStatus[OrderStatus["Active"] = 1] = "Active";
        OrderStatus[OrderStatus["Filled"] = 2] = "Filled";
        OrderStatus[OrderStatus["Expired"] = 3] = "Expired";
        OrderStatus[OrderStatus["Settled"] = 4] = "Settled";
        OrderStatus[OrderStatus["Void"] = 5] = "Void";
        OrderStatus[OrderStatus["Suspended"] = 6] = "Suspended";
    })(OrderStatus = GBET.OrderStatus || (GBET.OrderStatus = {}));
    let FreeBetEntitlementStatus;
    (function (FreeBetEntitlementStatus) {
        FreeBetEntitlementStatus[FreeBetEntitlementStatus["Active"] = 1] = "Active";
        FreeBetEntitlementStatus[FreeBetEntitlementStatus["Rescinded"] = 2] = "Rescinded";
        FreeBetEntitlementStatus[FreeBetEntitlementStatus["Lapsed"] = 3] = "Lapsed";
        FreeBetEntitlementStatus[FreeBetEntitlementStatus["Used"] = 4] = "Used";
    })(FreeBetEntitlementStatus = GBET.FreeBetEntitlementStatus || (GBET.FreeBetEntitlementStatus = {}));
    let PromotionStatus;
    (function (PromotionStatus) {
        PromotionStatus[PromotionStatus["Inactive"] = 1] = "Inactive";
        PromotionStatus[PromotionStatus["Upcoming"] = 2] = "Upcoming";
        PromotionStatus[PromotionStatus["Open"] = 3] = "Open";
        PromotionStatus[PromotionStatus["Closed"] = 4] = "Closed";
        PromotionStatus[PromotionStatus["Completed"] = 5] = "Completed";
        PromotionStatus[PromotionStatus["Abandoned"] = 6] = "Abandoned";
    })(PromotionStatus = GBET.PromotionStatus || (GBET.PromotionStatus = {}));
    let EntityType;
    (function (EntityType) {
        EntityType[EntityType["ZZNotUsed0"] = 0] = "ZZNotUsed0";
        EntityType[EntityType["EventClassifier"] = 1] = "EventClassifier";
        EntityType[EntityType["Market"] = 2] = "Market";
        EntityType[EntityType["Selection"] = 3] = "Selection";
    })(EntityType = GBET.EntityType || (GBET.EntityType = {}));
})(GBET || (exports.GBET = GBET = {}));
